// Helper function to get and set the wishlist from localStorage
function getWishlist() {
  return JSON.parse(localStorage.getItem('wishlist')) || [];
}

function saveWishlist(wishlist) {
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
}

// Check if the product is already in the wishlist
function isProductInWishlist(productId) {
  let wishlist = getWishlist();
  return wishlist.some(item => item.id === productId);
}

// Toggle the button between Add and Remove
function toggleWishlistButton(button, inWishlist) {
  const buttonText = button.querySelector('.wishlist-button-text');
  //let buttonClass = button.querySelector('.wishlist-toggle');
  if (inWishlist) {
    button.classList = 'wishlist-toggle remove';
    buttonText.textContent = 'Verwijderen uit verlanglijst';
  } else {
    button.classList = 'wishlist-toggle add';
    buttonText.textContent = 'Voeg toe aan verlanglijst';
  }
  updateWishlistCount();
}

// Function to add or remove product from wishlist
function handleWishlistToggle(productId, productHandle) {
  let wishlist = getWishlist();
  const inWishlist = isProductInWishlist(productId);

  if (inWishlist) {
    // Remove from wishlist
    wishlist = wishlist.filter(item => item.id !== productId);
    //alert('Product removed from wishlist!');
  } else {
    // Add to wishlist
    wishlist.push({ id: productId, handle: productHandle });
    //alert('Product added to wishlist!');
  }

  saveWishlist(wishlist);
  return !inWishlist;  // Return the new state (added or removed)
  updateWishlistCount();
}

// Add event listener to wishlist button
document.querySelectorAll('.wishlist-toggle').forEach(button => {
  const productId = parseInt(button.getAttribute('data-product-id'));
  const productHandle = button.getAttribute('data-product-handle');

  // Set the button text based on whether the product is in the wishlist
  toggleWishlistButton(button, isProductInWishlist(productId));

  button.addEventListener('click', function(e) {
    e.preventDefault();

    const productInWishlist = handleWishlistToggle(productId, productHandle);
    toggleWishlistButton(button, productInWishlist);  // Update the button text
  });
});

// Function to add product to the wishlist
function addToWishlist(productId, productHandle) {
  let wishlist = getWishlist();

  // Ensure productId is stored as an integer
  productId = parseInt(productId);

  if (!wishlist.find(item => item.id === productId)) {
    wishlist.push({ id: productId, handle: productHandle });
    saveWishlist(wishlist);
    //alert('Product added to wishlist!');
  } else {
    //alert('This product is already in your wishlist.');
  }
  updateWishlistCount();
}

// Function to remove product from the wishlist
function removeFromWishlist(productId) {
  let wishlist = getWishlist();

  // Ensure productId is an integer
  productId = parseInt(productId);

  // Remove the product from the wishlist array
  wishlist = wishlist.filter(item => item.id !== productId);

  // Update localStorage with the new wishlist array
  saveWishlist(wishlist);

  location.reload(); 
  
  // Re-render the wishlist page
  //displayWishlist();
}

// Display the wishlist when the page loads
document.addEventListener('DOMContentLoaded', displayWishlist);

// Custom function to format the price
function formatMoney(cents) {
  const dollars = (cents / 100).toFixed(2);
  return `€${dollars}`;
}

// Function to display wishlist items
function displayWishlist() {
  const wishlist = getWishlist();
  const wishlistContainer = document.getElementById('wishlist-container');
  
  if (wishlist.length === 0) {
    wishlistContainer.innerHTML = '<p>Je verlanglijst is leeg.</p>';
    return;
  }

  wishlistContainer.innerHTML = '';

  wishlist.forEach(item => {
    // Use AJAX to fetch product data
    fetch(`/products/${item.handle}.js`)
      .then(response => response.json())
      .then(product => {
        // Create product card to display on the wishlist page
        const productCard = document.createElement('div');
        productCard.classList.add('wishlist-item');
        productCard.innerHTML = `
          <div class="image-container">
            <a href="/products/${product.handle}">
              <img src="${product.images[0]}" alt="${product.title}">
            </a>
            <button class="remove-from-wishlist" data-product-id="${product.id}">Verwijderen uit verlanglijst</button>
          </div>
          <a href="/products/${product.handle}">
            <h3>${product.title}</h3>
          </a>
          <div class="jdgm-star-rating" data-id="${product.id}"></div>
          <p>Prijs: ${formatMoney(product.price)}</p>
        `;
        
        wishlistContainer.appendChild(productCard);

        loadJudgeMeWidgets();
      });
  });
}

function loadJudgeMeWidgets() {
  if (typeof window.judgeme !== 'undefined' && typeof window.judgeme.widgets !== 'undefined') {
    window.judgeme.widgets.init(); // Initializes Judge.me widgets for the dynamically added content
  } else {
    // Judge.me script might take some time to load, so we retry
    setTimeout(loadJudgeMeWidgets, 500);
  }
}

// Remove product from wishlist
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('remove-from-wishlist')) {
    const productId = e.target.getAttribute('data-product-id');
    removeFromWishlist(productId);
    displayWishlist(); // Re-render the wishlist after removal
  }
});

// Display the wishlist when the page loads
document.addEventListener('DOMContentLoaded', displayWishlist);

// Function to update the wishlist count in the header
function updateWishlistCount() {
  const wishlist = getWishlist();
  const wishlistCount = document.querySelector('.wishlist-count');

  if (wishlistCount) {
    wishlistCount.textContent = wishlist.length;
  }
}

// Call the updateWishlistCount function when the page loads
document.addEventListener('DOMContentLoaded', function() {
  updateWishlistCount();
});

document.querySelector('#product-title').appendChild(document.querySelector('#wishlist')); 